"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var Label_1 = __importDefault(require("./Label"));
exports.Label = Label_1.default;
exports.default = Label_1.default;
//# sourceMappingURL=index.js.map